const MAX_BYTES = 5 * 1024 * 1024;
const ALLOWED_MIME = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/gif']);
const ALLOWED_EXT = new Set(['jpg', 'jpeg', 'png', 'webp', 'gif']);

function extFromName(name) {
  return String(name || '').split('.').pop().toLowerCase();
}

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error('Falha ao processar imagem.'))),
      type,
      quality
    );
  });
}

function loadImageFromFile(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Não foi possível ler a imagem.'));
    };
    img.src = url;
  });
}

/**
 * Valida e compacta imagem para ~70% do tamanho original (máx. 5MB).
 */
export async function compressEquipImage(file) {
  if (!file) throw new Error('Arquivo inválido.');
  if (file.size > MAX_BYTES) throw new Error('Imagem acima de 5MB.');

  const mime = String(file.type || '').toLowerCase();
  const ext = extFromName(file.name);
  if (!ALLOWED_MIME.has(mime) && !ALLOWED_EXT.has(ext)) {
    throw new Error('Formato não permitido. Use JPG, PNG, WebP ou GIF.');
  }

  const targetMax = Math.max(32 * 1024, Math.floor(file.size * 0.7));
  const img = await loadImageFromFile(file);
  const canvas = document.createElement('canvas');
  canvas.width = img.naturalWidth || img.width;
  canvas.height = img.naturalHeight || img.height;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Falha ao processar imagem.');
  ctx.drawImage(img, 0, 0);

  let quality = 0.9;
  let blob = await canvasToBlob(canvas, 'image/jpeg', quality);
  while (blob.size > targetMax && quality > 0.45) {
    quality -= 0.07;
    blob = await canvasToBlob(canvas, 'image/jpeg', quality);
  }

  if (blob.size > MAX_BYTES) {
    throw new Error('Não foi possível compactar a imagem abaixo de 5MB.');
  }

  const baseName = String(file.name || 'imagem').replace(/\.[^.]+$/, '') || 'imagem';
  return new File([blob], `${baseName}.jpg`, {
    type: 'image/jpeg',
    lastModified: Date.now(),
  });
}

export const EQUIP_IMAGE_MAX_BYTES = MAX_BYTES;
